import React, { useState } from 'react';
import { BarChart3, Users, ShieldAlert, Ticket, LayoutDashboard, BookOpen, Settings2, Package, Download, Upload } from 'lucide-react';
import PageShell from '../../components/PageShell';
import AdminDashboard from './AdminDashboard';
import ApiAnalytics from './ApiAnalytics';
import UserManagement from './UserManagement';
import AdminTickets from './AdminTickets';
import AdminDocs from './AdminDocs';
import AdminSources from './AdminSources';
import AdminOrders from './AdminOrders';
import AdminBillingConfig from './AdminBillingConfig';
import AdminDownloads from './AdminDownloads';
import AdminUpload from './AdminUpload';

const TABS = [
  { key: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { key: 'analytics', label: 'API Analytics', icon: BarChart3 },
  { key: 'users', label: 'Users', icon: Users },
  { key: 'tickets', label: 'Tickets', icon: Ticket },
  { key: 'orders', label: 'Orders', icon: Package },
  { key: 'billing', label: 'Billing', icon: Settings2 },
  { key: 'downloads', label: 'Downloads', icon: Download },
  { key: 'upload', label: 'Upload', icon: Upload },
  { key: 'sources', label: 'Sources', icon: Settings2 },
  { key: 'docs', label: 'Docs', icon: BookOpen },
];

export default function AdminLayout() {
  const [activeTab, setActiveTab] = useState('dashboard');

  return (
    <PageShell title="Admin">
      <div className="p-5" data-testid="admin-page">
        {/* Admin badge */}
        <div className="flex items-center gap-2 mb-4">
          <ShieldAlert className="w-4 h-4 text-amber-400/70" />
          <span className="text-[10px] uppercase tracking-widest text-amber-400/60 font-medium">Admin Panel</span>
        </div>

        {/* Tabs */}
        <div className="flex flex-wrap gap-1.5 mb-5">
          {TABS.map(t => (
            <button
              key={t.key}
              data-testid={`admin-tab-${t.key}`}
              onClick={() => setActiveTab(t.key)}
              className={`text-[10px] px-3 py-2 rounded-full inline-flex items-center gap-1.5 transition-all font-medium ${
                activeTab === t.key
                  ? 'bg-primary/15 text-primary border border-primary/30'
                  : 'bg-white/5 text-muted-foreground border border-white/5 hover:border-white/10'
              }`}
            >
              <t.icon className="w-3.5 h-3.5" />
              {t.label}
            </button>
          ))}
        </div>

        {/* Tab content */}
        {activeTab === 'dashboard' && <AdminDashboard />}
        {activeTab === 'analytics' && <ApiAnalytics />}
        {activeTab === 'users' && <UserManagement />}
        {activeTab === 'tickets' && <AdminTickets />}
        {activeTab === 'orders' && <AdminOrders />}
        {activeTab === 'billing' && <AdminBillingConfig />}
        {activeTab === 'downloads' && <AdminDownloads />}
        {activeTab === 'upload' && <AdminUpload />}
        {activeTab === 'sources' && <AdminSources />}
        {activeTab === 'docs' && <AdminDocs />}
      </div>
    </PageShell>
  );
}
